export enum DeviceType {
  Mobile,
  Desktop,
}

export const isMobileFromUA = (UA: string | undefined) => {
  const isMobile = UA
    ? Boolean(UA.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))
    : false;

  return isMobile ? DeviceType.Mobile : DeviceType.Desktop;
};
